import { types, applySnapshot } from "mobx-state-tree";
import { Framework } from "@flint/framework";

const AddAdminModel = types
  .model("AddAdminModel", {
    res: types.string,
    stat: types.string
  })
  .actions((self) => ({
    fetch() {
      Framework.sendEvent("ADDING_ADMIN_DATA");
    },
    set(response) {
      let status = response.data.response;
      let data;
      if (status === "SUCCESS") {
        data = `The Administrator has been added successfully! Please create a ticket on ServiceNow as well!`;
      } else if (status === "Record Exists") {
        data = `This Administrator already exists!`
      } else {
        data = status;
      }
      applySnapshot(self, {
        res: data,
        stat: status
      });
    },
    reset() {
      applySnapshot(self, {
        res: "Oops...Something went wrong. Please try again.",
        stat: ""
      });
    },
  }));

export default AddAdminModel;
